import { Navigate } from 'react-router-dom';
import { useAuth } from '../services/authentication/authContext';
import { canAccessAnalysisPage, isInvoiceOnlyAccount } from '../services/accessManagement/accessManagement';

/**
 * Gates the Analysis pages behind the per-account `analysis_page` flag
 * (admin-only, off for every customer in v1; force-on for impersonating super admins).
 * Redirects to the dashboard when the account does not have the feature. Invoice-only
 * accounts are excluded like in the navs (InvoiceOnlyRedirect also sends them to /home);
 * restricted staff are blocked by `blockedMainPages` in mainPageRestriction.ts.
 */
export function AnalysisRoute({ children }: { children: JSX.Element }) {
  const { backendUser, accountSettings } = useAuth();
  if (isInvoiceOnlyAccount(backendUser, accountSettings) || !canAccessAnalysisPage(backendUser, accountSettings)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
